export default "__VITE_ASSET__CRnXr34k__"